// src/app/session-storage.service.ts

import { Injectable } from '@angular/core';
import { CommonConstants } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  constructor() {}

  // Set item in sessionStorage
  public setItem<T>(key: string, value: T): void {
    try {
      // Serialize the value into JSON string before storing
      const serializedValue = JSON.stringify(value);
      sessionStorage.setItem(key, serializedValue);
    } catch (e) {
      console.error('Error setting item in sessionStorage', e);
    }
  }

  // Get item from sessionStorage
  public getItem<T>(key: string): T | null {
    try {
      const serializedValue = sessionStorage.getItem(key);
      // If there's no item, return null
      if (!serializedValue) {
        return null;
      }
      // Deserialize the value back to the original type
      return JSON.parse(serializedValue) as T;
    } catch (e) {
      console.error('Error getting item from sessionStorage', e);
      return null;
    }
  }

  // Remove item from sessionStorage
  public removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      console.error('Error removing item from sessionStorage', e);
    }
  }

  // Clear all sessionStorage
  public clear(): void {
    try {
      sessionStorage.clear();
    } catch (e) {
      console.error('Error clearing sessionStorage', e);
    }
  }

  // Check if an item exists in sessionStorage
  public exists(key: string): boolean {
    return sessionStorage.getItem(key) !== null;
  }
  public isInternalUser(): boolean {
    return this.getItem<string>(CommonConstants.IsInternalUser) === 'true';
  }
  public isCustomerUser(): boolean {
    return this.getItem<string>(CommonConstants.IsCustomerUser) === 'true';
  }
  public isForeignUser(): boolean {
    return this.getItem<string>(CommonConstants.IsForeignUser) === 'true';
  }
}
